import { SYSAction, SYSTableDefIds } from "../../../../../../../_ovlclient/src"
import { FormInit } from "../../../../../../../_ovlclient/src/library/forms/formapi"
import { TableRefresh } from "../../../../../../../_ovlclient/src/library/table/tableapi"
import { searchPaketFields } from "../../../features/datdocuments/searchpaket/tabledef"

const HookScreenRefresh: SYSAction = async (_, { global }) => {
  let state = global.getState()
  TableRefresh("DATSearchPaket", {
    forcedFilters: {
      staticFilter: {
        U_OrderDocEntry:
          state.app.screens.DATOrder.orderDetail.orders[
            state.app.screens.DATOrder.orderDetailFormState.selectedOrder
          ]["docEntry"].toString(),
      },
    },
  })
}

const HookScreenNavigateIn: SYSAction = async (_, { global }) => {
  let state = global.getState()
  await TableRefresh("DATSearchPaket", {
    resetStrategy: { Filter: true, Sort: true },
    forcedFilters: {
      staticFilter: {
        U_OrderDocEntry:
          state.app.screens.DATOrder.orderDetail.orders[
            state.app.screens.DATOrder.orderDetailFormState.selectedOrder
          ]["docEntry"].toString(),
      },
    },
  })
  await FormInit("DATSearchPaket", searchPaketFields, {
    forceOverwrite: true,
    initialFocusFieldKey: "Search",
  })
}

let hooks = { HookScreenNavigateIn, HookScreenRefresh }
export let DATSearchPaket = { hooks }
